import { AxiosError } from 'axios';
import { Card } from 'components/common';
import { CommonButton as Button } from 'components/common/Forms/Button';
import {
  CloseButton,
  DialogFormWrapper,
  FormActionsStyle,
  FormBody,
  FormHeader,
  FormRow,
  FormTitle,
} from 'components/common/Forms/Forms.styled';
import Input from 'components/common/Forms/Input';
import { CardLoader } from 'components/common/Loading';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FaClipboardList, FaTimes } from 'react-icons/fa';
import { ApptOption, ApptOptionsFormValues } from 'types/apptOptions';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';

interface Props {
  closeFormHandler: (err?: string | AxiosError<any>) => void;
  submitHandler: (data: ApptOptionsFormValues) => void;
  isLoading: boolean;
  prefilledData?: ApptOption;
  handleDeleteApptOption: (value: string) => void;
}

export const ApptOptionsForm = ({
  closeFormHandler,
  submitHandler,
  isLoading,
  handleDeleteApptOption,
  prefilledData,
}: Props) => {
  const { t } = useCommonTranslation();
  const {
    register,
    handleSubmit,
    setFocus,
    formState: { errors },
  } = useForm<ApptOptionsFormValues>({
    defaultValues: prefilledData
      ? {
          name: prefilledData.name,
        }
      : {},
  });

  useEffect(() => {
    setFocus('name');
  }, [setFocus]);

  return (
    <Card>
      <DialogFormWrapper>
        <CloseButton
          size="auto"
          variant="primary"
          iconOnly
          onClick={() => closeFormHandler()}
        >
          <FaTimes />
        </CloseButton>
        <FormHeader>
          <FaClipboardList />
          <FormTitle>{t('appointment-option')}</FormTitle>
        </FormHeader>
        <FormBody onSubmit={handleSubmit(submitHandler)}>
          <FormRow>
            <Input
              label={t('name')}
              placeholder={t('name')}
              helperText={errors.name?.message}
              hasError={Boolean(errors.name)}
              {...register('name', {
                required: t('must-not-empty') as string,
              })}
              required
            />
          </FormRow>
          <FormActionsStyle align="center">
            <Button variant="primary" type="submit">
              {prefilledData ? t('save') : t('add')}
            </Button>
            {prefilledData && (
              <Button
                variant="danger"
                type="button"
                onClick={() => handleDeleteApptOption(prefilledData.id)}
              >
                {t('delete')}
              </Button>
            )}
            <Button
              type="button"
              variant="secondary"
              onClick={() => closeFormHandler()}
            >
              {t('cancel')}
            </Button>
          </FormActionsStyle>
        </FormBody>
        {isLoading && <CardLoader fillWrapper={true} />}
      </DialogFormWrapper>
    </Card>
  );
};
